import '../../../../../lib/assets/javascripts/devex/util';
import '../directives/track_report_button.directive';
import template from './report_result.template.html?raw';

const controller = function () {
  const that = this;

  that.isSignedIn = devex.data.userSignedIn;

  /**
   * After all the bindings are defined, we'll define those functions so that we don't send
   * any errors to AppSignal on first init
   *
   * @returns {undefined}
   */
  that.$onInit = () => {
    /**
     * Check against a `type` argument (either a string or an Array) if the report's type shown
     * in the directive (the `report` binding) matches the arg. Returns a boolean. Used for
     * CSS purposes.
     *
     * @param {Array | string} type - An array or a string indicating the type of report
     *
     * @returns {boolean} - If one type, passed as arg, correspond to report type, return true,
     *                      else, if none matches report type, return false
     */
    that.isOfType = (type) => {
      if (typeof type === 'string') {
        return that.report.type === type;
      }

      return type.some((typeName) => that.report.type === typeName);
    };

    /**
     * Determines what is the display name of the report ('report' binding)
     *
     * @returns {string} - Returns the displayed title of the report ('report' binding)
     */
    that.getDisplayTitle = () => {
      const title = that.report.editorialized_title || that.report.title;
      return !title ? that.report.summarized_description : title;
    };

    /**
     * Checks if donor section should be shown on the report-result directive. If no donors are
     * returned by BE (for UA's for example), returns false.
     *
     * @returns {boolean} - Indicates whether or not we'll show the donors section
     */
    that.showDonors = () => {
      if (that.report.donors && that.report.donors.length) {
        return true;
      }
      return false;
    };

    /**
     * Determines what is the display name of the report ('report' binding)
     *
     * @param {Object} rep - Report object with all its properties
     *
     * @returns {string} - Returns the displayed title of the report ('report' binding)
     */
    that.getShowDate = (rep) =>
      that.isOfType('funding_info') ? rep.discovery_date : rep.updated_at;

    /**
     * Returns true if a given date of a report is larger than limit
     *
     * @param {object} report - Funding report
     * @param {number} limit - Time limit
     *
     * @returns {boolean} - true if the date is larger than limit
     */
    that.showRecentResultTooltip = (report, limit) => {
      return devex.util.differenceInDays(new Date(that.getShowDate(report)), new Date()) > limit;
    };
  };
};

angular
  .module('fundingSearchApp.components.reportResult', [])
  .run([
    '$templateCache',
    function ($templateCache) {
      $templateCache.put(template, template);
    },
  ])
  .component('reportResult', {
    controller,
    templateUrl: template,
    controllerAs: 'vm',
    bindings: {
      report: '<',
      activeReport: '<',
      toggleTrackReport: '<',
      userPermissions: '<',
    },
  });
